import { Button } from '@/components/ui/button'
import { Briefcase, Grid3X3, List } from 'lucide-react'

interface JobListingHeaderProps {
  totalListings: number
  viewMode: 'grid' | 'list'
  onViewModeChange: (mode: 'grid' | 'list') => void
}

/**
 * Header section for job listings with view mode controls and stats
 */
export function JobListingHeader({
  totalListings,
  viewMode,
  onViewModeChange,
}: JobListingHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h2 className="text-3xl font-bold">Latest Opportunities</h2>
        <div className="flex items-center gap-2 mt-2">
          <Briefcase className="w-4 h-4 text-muted-foreground" />
          <span className="text-muted-foreground">{totalListings} active listings available</span>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          variant={viewMode === 'grid' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewModeChange('grid')}
          className="flex items-center gap-2"
        >
          <Grid3X3 className="w-4 h-4" />
          Grid
        </Button>
        <Button
          variant={viewMode === 'list' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewModeChange('list')}
          className="flex items-center gap-2"
        >
          <List className="w-4 h-4" />
          List
        </Button>
      </div>
    </div>
  )
}
